import axios from 'axios';
import i18n from '@/i18n';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BACKEND_URL + '/api/';

class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'login', {
                email: user.email,
                password: user.password
            })
            .then(response => {
                if (response.data.status === 'success' && response.data.data.user.email_verified_at !== null) {
                    i18n.global.locale.value = response.data.data.user.locale;
                    localStorage.setItem('locale', response.data.data.user.locale);
                    localStorage.setItem('loggedData', JSON.stringify(response.data.data));

                    if (response.data.data.user.company && response.data.data.user.company.total_branches > 0) {
                        if (localStorage.getItem('branch') === null) {
                            localStorage.setItem('branch', JSON.stringify(response.data.data.user.company.branches[0]));
                        }
                    }
                }

                return response.data;
            });
    }

    logout() {
        localStorage.clear();
    }

    register(user) {
        return axios.post(API_URL + 'register', user);
    }

    verify(user) {
        return axios.post(API_URL + 'verify', {
            email: user.email,
        });
    }

    resend(email) {
        return axios.post(API_URL + 'verify/resend', {
            email: email,
        });
    }

    changePassword(user) {
        return axios.post(API_URL + 'forgot-password', {
            email: user.email,
            generate_token: 1,
        });
    }

    forgotPassword(user) {
        return axios.post(API_URL + 'forgot-password', {
            email: user.email,
        });
    }

    resetPassword(user) {
        return axios.post(API_URL + 'reset-password', {
            reset_token: user.resetToken,
            password: user.password,
        });
    }

    setLocale(locale) {
        return axios.get(API_URL + 'set-locale' + '/' + locale, { headers: authHeader() }).then(response => {
            if (response.data.status === 'success') {
                i18n.global.locale.value = locale;
                localStorage.setItem('locale', locale);
            }

            return response;
        });
    }
}

export default new AuthService();
